module.exports = __webpack_public_path__ + "static/media/users.5a1f4dd8.svg";